module.exports = __webpack_public_path__ + "img/bg.2b86eacf.png";